import { motion } from "framer-motion";

export const DIMENSIONS = [
  { key: "physical", name: "Physical Wellness", short: "Physical" },
  { key: "inheritance", name: "Inheritance & Personal History", short: "History" },
  { key: "environmental", name: "Environmental Wellness", short: "Environment" },
  { key: "emotional", name: "Emotional Wellness", short: "Emotional" },
  { key: "spiritual", name: "Spiritual Wellness", short: "Spiritual" },
];

export const DimensionRadar = ({ values, size = 360 }) => {
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 62;
  const ang = (i) => (2 * Math.PI * i) / 5 - Math.PI / 2;
  const pt = (i, v) => [cx + Math.cos(ang(i)) * r * (v / 100), cy + Math.sin(ang(i)) * r * (v / 100)];
  const ringPts = (v) => [0, 1, 2, 3, 4].map((i) => pt(i, v).join(",")).join(" ");
  const dataPts = values.map((v, i) => pt(i, v).join(",")).join(" ");

  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      className="h-auto w-full"
      role="img"
      aria-label="Illustrative chart of the five wellness dimensions"
    >
      {[25, 50, 75, 100].map((v) => (
        <polygon
          key={v}
          points={ringPts(v)}
          fill={v === 100 ? "#E5ECE3" : "none"}
          fillOpacity={v === 100 ? 0.35 : 0}
          stroke="#173F35"
          strokeOpacity={v === 100 ? 0.22 : 0.09}
        />
      ))}
      {[0, 1, 2, 3, 4].map((i) => {
        const [x, y] = pt(i, 100);
        return <line key={i} x1={cx} y1={cy} x2={x} y2={y} stroke="#173F35" strokeOpacity="0.12" />;
      })}
      <motion.polygon
        points={dataPts}
        fill="#B49253"
        fillOpacity="0.22"
        stroke="#B49253"
        strokeWidth="2"
        strokeLinejoin="round"
        initial={{ opacity: 0, scale: 0.65 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.15, ease: [0.22, 1, 0.36, 1] }}
        style={{ transformOrigin: `${cx}px ${cy}px` }}
      />
      {values.map((v, i) => {
        const [x, y] = pt(i, v);
        return (
          <motion.circle
            key={i}
            cx={x}
            cy={y}
            r="4.5"
            fill="#173F35"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 + i * 0.08 }}
          />
        );
      })}
      {DIMENSIONS.map((d, i) => {
        const [x, y] = pt(i, 126);
        return (
          <text
            key={d.key}
            x={x}
            y={y}
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="11"
            fontWeight="700"
            letterSpacing="1.6"
            fill="#173F35"
          >
            {d.short.toUpperCase()}
          </text>
        );
      })}
    </svg>
  );
};
